var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFairLaunchIconBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5836 16.3458H23.9018L14.5836 6.98137C14.4825 6.87061 14.3596 6.78217 14.2226 6.72167C14.0857 6.66118 13.9377 6.62994 13.7882 6.62994C13.6386 6.62994 13.4906 6.66118 13.3537 6.72167C13.2168 6.78217 13.0938 6.87061 12.9927 6.98137L9.64043 10.3503C9.53422 10.4549 9.39142 10.5135 9.2427 10.5135C9.09397 10.5135 8.95118 10.4549 8.84497 10.3503L7.9927 9.49378L8.90179 8.58018L13.7882 3.66957L18.6745 8.58018C18.8843 8.79535 19.1702 8.91849 19.47 8.92278H24.5836C24.885 8.92278 25.174 8.80246 25.3871 8.58829C25.6002 8.37413 25.72 8.08365 25.72 7.78078C25.72 7.4779 25.6002 7.18743 25.3871 6.97326C25.174 6.75909 24.885 6.63877 24.5836 6.63877H19.9245L14.5836 1.27136C14.4825 1.16059 14.3596 1.07216 14.2226 1.01166C14.0857 0.951162 13.9377 0.919922 13.7882 0.919922C13.6386 0.919922 13.4906 0.951162 13.3537 1.01166C13.2168 1.07216 13.0938 1.16059 12.9927 1.27136L7.65179 6.63877H1.85633C1.55495 6.63877 1.26591 6.75909 1.0528 6.97326C0.839694 7.18743 0.719971 7.4779 0.719971 7.78078C0.719971 8.08365 0.839694 8.37413 1.0528 8.58829C1.26591 8.80246 1.55495 8.92278 1.85633 8.92278H5.60633C5.4863 9.22357 5.46006 9.55392 5.53109 9.87003C5.60212 10.1862 5.76707 10.4731 6.00406 10.6929L7.25406 11.9491C7.78511 12.4722 8.49908 12.7652 9.2427 12.7652C9.98631 12.7652 10.7003 12.4722 11.2313 11.9491L13.7882 9.37958L22.6518 18.2872C22.8616 18.5024 23.1475 18.6255 23.4472 18.6298H24.5836C24.885 18.6298 25.174 18.5095 25.3871 18.2953C25.6002 18.0812 25.72 17.7907 25.72 17.4878C25.72 17.1849 25.6002 16.8945 25.3871 16.6803C25.174 16.4661 24.885 16.3458 24.5836 16.3458Z",
    fill: "url(#paint0_linear_8805_2010)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4245 14.9755C17.2057 14.8105 16.935 14.7305 16.6621 14.7499C16.3893 14.7694 16.1326 14.8872 15.9392 15.0816C15.7457 15.2759 15.6286 15.5339 15.6092 15.8081C15.5898 16.0823 15.6695 16.3544 15.8336 16.5743L19.8109 20.5713C19.912 20.6821 20.0349 20.7705 20.1719 20.831C20.3088 20.8915 20.4567 20.9227 20.6063 20.9227C20.7559 20.9227 20.9039 20.8915 21.0408 20.831C21.1777 20.7705 21.3007 20.6821 21.4018 20.5713C21.512 20.4697 21.6 20.3461 21.6602 20.2085C21.7204 20.0709 21.7515 19.9222 21.7515 19.7719C21.7515 19.6216 21.7204 19.4729 21.6602 19.3353C21.6 19.1976 21.512 19.0741 21.4018 18.9725L17.4245 14.9755Z",
    fill: "url(#paint1_linear_8805_2010)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0154 16.6884C13.7966 16.5234 13.5259 16.4433 13.253 16.4628C12.9802 16.4823 12.7235 16.6001 12.53 16.7944C12.3366 16.9888 12.2195 17.2468 12.2001 17.521C12.1807 17.7952 12.2604 18.0672 12.4245 18.2872L16.4018 22.2842C16.5029 22.3949 16.6258 22.4834 16.7627 22.5439C16.8997 22.6044 17.0476 22.6356 17.1972 22.6356C17.3468 22.6356 17.4947 22.6044 17.6317 22.5439C17.7686 22.4834 17.8915 22.3949 17.9927 22.2842C18.1029 22.1825 18.1909 22.059 18.2511 21.9214C18.3113 21.7838 18.3424 21.6351 18.3424 21.4848C18.3424 21.3345 18.3113 21.1858 18.2511 21.0482C18.1909 20.9105 18.1029 20.787 17.9927 20.6854L14.0154 16.6884Z",
    fill: "url(#paint2_linear_8805_2010)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0382 17.8305C9.81932 17.6655 9.54863 17.5854 9.27578 17.6049C9.00293 17.6244 8.74623 17.7422 8.55281 17.9365C8.35938 18.1309 8.24222 18.3889 8.22283 18.6631C8.20344 18.9373 8.28312 19.2093 8.44725 19.4293L12.4245 23.4263C12.5256 23.537 12.6486 23.6255 12.7855 23.686C12.9224 23.7465 13.0704 23.7777 13.22 23.7777C13.3696 23.7777 13.5175 23.7465 13.6544 23.686C13.7914 23.6255 13.9143 23.537 14.0154 23.4263C14.1256 23.3246 14.2136 23.2011 14.2738 23.0635C14.334 22.9259 14.3651 22.7772 14.3651 22.6269C14.3651 22.4765 14.334 22.3279 14.2738 22.1902C14.2136 22.0526 14.1256 21.9291 14.0154 21.8275L10.0382 17.8305Z",
    fill: "url(#paint3_linear_8805_2010)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78815 16.6888C3.57835 16.4736 3.29244 16.3505 2.9927 16.3462H1.85633C1.55495 16.3462 1.26591 16.4665 1.0528 16.6807C0.839694 16.8948 0.719971 17.1853 0.719971 17.4882C0.719971 17.7911 0.839694 18.0815 1.0528 18.2957C1.26591 18.5099 1.55495 18.6302 1.85633 18.6302H2.53815L8.44724 24.5686C8.54837 24.6794 8.6713 24.7678 8.80823 24.8283C8.94517 24.8888 9.09312 24.92 9.2427 24.92C9.39228 24.92 9.54023 24.8888 9.67716 24.8283C9.8141 24.7678 9.93703 24.6794 10.0382 24.5686C10.1484 24.467 10.2364 24.3434 10.2966 24.2058C10.3568 24.0682 10.3879 23.9195 10.3879 23.7692C10.3879 23.6189 10.3568 23.4702 10.2966 23.3326C10.2364 23.195 10.1484 23.0714 10.0382 22.9698L3.78815 16.6888Z",
    fill: "url(#paint4_linear_8805_2010)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8805_2010",
    x1: 0.719971,
    y1: 9.77486,
    x2: 25.72,
    y2: 9.77486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8805_2010",
    x1: 15.6063,
    y1: 17.8349,
    x2: 21.7515,
    y2: 17.8349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8805_2010",
    x1: 12.1972,
    y1: 19.5478,
    x2: 18.3424,
    y2: 19.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8805_2010",
    x1: 8.21997,
    y1: 20.6899,
    x2: 14.3651,
    y2: 20.6899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8805_2010",
    x1: 0.719971,
    y1: 20.6331,
    x2: 10.3879,
    y2: 20.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairLaunchIconBottom);
export default __webpack_public_path__ + "static/media/FairLaunchIconBottom.703f635bb92f2cc856a9def84c97f028.svg";
export { ForwardRef as ReactComponent };